class TestSuiteExpiryReportController {
    constructor($browser, $window, $location, toastr, moment, ngProgressFactory, SettingsService, UserDetailsApi, ReportUtilityServiceApi, ReportServiceApi, ReportUtils) {
        this.dateCellRenderer = (row) => {
            const date = row.data.ExpiryDate;
            // @ts-ignore no entry for _.isNill in the lodash interface
            if (_.isNil(date)) {
                return '';
            }
            const time = [
                '<span>',
                this.moment(date).format(this.state.DateFormats.DateTimeFormat),
                '</span>'
            ].join('');
            return time;
        };
        this.statusCellRenderer = (row) => {
            let rowData = row.data;
            let statusText = '';
            let iconCode = '';
            let popOverMessage = '';
            let popOverGeneralCode = '';
            let popOverIcon = '';
            // @ts-ignore no entry for _.isNill in the lodash interface
            if (!_.isNil(row.data.ExpiryDate)) {
                const expiryDate = this.moment(rowData.ExpiryDate).format(this.state.DateFormats.DateFormat);
                let colour = 'traffic-success';
                let popupText = 'Will expire on ';
                if (rowData.Status === 'Expired') {
                    colour = 'traffic-danger';
                    popupText = 'Expired on ';
                }
                else if (rowData.Status === 'Expiring Soon') {
                    colour = 'traffic-warning';
                    popupText = 'Expiring on ';
                }
                popOverMessage = ['uib-popover="', popupText, expiryDate, '"'].join('');
                iconCode = [
                    '<span class="traffic-circle ',
                    this.state.statusIconSize,
                    ' ',
                    colour,
                    '-bg"'
                ].join('');
            }
            else {
                popOverMessage = [
                    'uib-popover="No expiry date for this Suite"'
                ].join('');
                iconCode = [
                    '<span class="traffic-circle ',
                    this.state.statusIconSize,
                    '"'
                ].join('');
            }
            if (this.state.statusPopups) {
                popOverGeneralCode = [
                    popOverMessage,
                    'popover-placement="right"',
                    'popover-append-to-body="true"',
                    'popover-animation popover-trigger="\'mouseenter\'"'
                ].join('');
            }
            if (this.state.statusIcon) {
                popOverIcon = [iconCode, popOverGeneralCode, '></span> '].join('');
            }
            if (this.state.statusText) {
                statusText = row.data.Status;
            }
            const status = [popOverIcon, statusText].join('');
            return status;
        };
        this.onSizeChange = () => {
            this.gridOptions.api.sizeColumnsToFit();
        };
        this.toggleExpiryOnly = () => {
            this.state.expiryOnly = !this.state.expiryOnly;
            this.state.selectedExpiryType = this.data.expiryTypes[0];
            this.filterRows();
            this.gridOptions.api.setRowData(this.data.rows);
        };
        this.filterRows = () => {
            if (this.state.expiryOnly) {
                this.data.rows = this.data.filterOptions.expiryOnly;
            }
            else {
                this.data.rows = this.data.filterOptions.allRows;
            }
        };
        this.exportCsv = () => {
            const reportName = this.ReportService.addDateToTitle(this.testSuiteExpiryReport.Description + '.csv');
            let params = {
                fileName: reportName
            };
            this.gridOptions.api.exportDataAsCsv(params);
        };
        this.onModelUpdated = () => {
            const model = this.gridOptions.api.getModel();
            const processedRows = model.getRowCount();
            this.rowCount = processedRows.toLocaleString();
        };
        this.getTestSuiteExpiryReport = () => {
            this.traceProgress.start();
            this.ReportServiceApi.getTestSuiteExpiryReport().then((response) => {
                if (response) {
                    const allRows = response.data;
                    const filteredRows = _.filter(allRows, (suite) => {
                        // @ts-ignore lodash
                        return !_.isNil(suite.ExpiryDate);
                    });
                    this.data.filterOptions = {
                        allRows: allRows,
                        expiryOnly: filteredRows
                    };
                    this.generateExpiryTypes();
                    this.filterRows();
                    try {
                        this.gridOptions.api.setRowData(this.data.rows);
                        this.gridOptions.api.sizeColumnsToFit();
                    }
                    catch (ex) {
                        angular.noop();
                    }
                    this.traceProgress.complete();
                }
            });
        };
        this.generateExpiryTypes = () => {
            // @ts-ignore lodash
            const types = _.uniqBy(_.map(this.data.filterOptions.allRows, (suite) => {
                let status = suite.Status;
                // @ts-ignore lodash
                if (!_.isNil(suite.ExpiryDate)) {
                    status = suite.Status;
                }
                return { Id: suite.Id, Name: status };
            }), 'Name');
            // @ts-ignore
            this.data.expiryTypes = _.concat({ Id: 0, Name: 'All Expiry Types' }, types);
        };
        this.selectExpiryType = (selection) => {
            this.state.expiryOnly = false;
            this.state.selectedExpiryType = this.data.expiryTypes[0];
            if (selection !== undefined ||
                (selection !== null &&
                    Object.prototype.toString.call(selection) === '[object Object]')) {
                // console.debug("Have Tester");
                this.state.selectedExpiryType = selection;
            }
            let filteredData = this.data.filterOptions.allRows;
            if (this.state.selectedExpiryType.Id > 0) {
                if (_.includes(this.state.selectedExpiryType.Name, 'Unlimited')) {
                    filteredData = _.filter(this.data.filterOptions.allRows, (suite) => {
                        // @ts-ignore lodash
                        return _.isNil(suite.ExpiryDate);
                    });
                }
                else {
                    filteredData = _.filter(this.data.filterOptions.allRows, (suite) => {
                        return (suite.Status === selection.Name &&
                            // @ts-ignore lodash
                            !_.isNil(suite.ExpiryDate));
                    });
                }
            }
            this.gridOptions.api.setRowData(filteredData);
        };
        // Initialise component with $onInit
        this.$onInit = () => {
            this.state = {
                showFilters: true,
                showExpiryFilter: true,
                showToggleExpiryButton: true,
                hideNav: _.startsWith(this.location.path(), '/Reports'),
                expiryOnly: false,
                statusIcon: true,
                statusPopups: true,
                statusText: true,
                statusIconSize: 'medium',
                DateFormats: {},
                showReport: false,
                selectedExpiryType: {},
                userDetails: {},
                expiryLimit: 0
            };
            this.data = {
                rows: [],
                expiryTypes: [],
                filterOptions: {}
                // testSuites: []
            };
            this.traceProgress = this.ngProgressFactory.createInstance();
            this.columnDefs = [
                {
                    headerName: 'Id',
                    field: 'Id',
                    width: 75,
                    minWidth: 75,
                    hide: true,
                    suppressSizeToFit: true
                },
                {
                    headerName: 'Name',
                    field: 'TestSuiteName',
                    minWidth: 105
                },
                {
                    headerName: 'Expiry Date',
                    field: 'ExpiryDate',
                    width: 145,
                    minWidth: 145,
                    cellRenderer: this.dateCellRenderer,
                    suppressSizeToFit: true,
                    sort: 'desc'
                },
                // { headerName: "Status", field: "Status", width: 105, minWidth: 105 },
                {
                    headerName: 'Status',
                    field: 'Status',
                    width: 130,
                    minWidth: 130,
                    cellRenderer: this.statusCellRenderer,
                    suppressSizeToFit: true
                },
                {
                    headerName: 'Sims Using #',
                    field: 'SimulatorAssignments',
                    width: 155,
                    minWidth: 155,
                    suppressSizeToFit: true
                }
                // ,{ headerName: "Users Using #", field: "UserAssignments", width: 160, minWidth: 160 }
            ];
            // @ts-ignore: Report clashes with dom.lib.d.ts Report
            this.testSuiteExpiryReport = {
                Id: 0,
                Name: '',
                Description: 'Test Suite Expiry Report',
                Route: '',
                Component: '',
                Icon: '',
                IsDeleted: false,
                LastAmended: null,
                LastAmendedBy: 0,
                ReportOrder: 0,
                IsExternal: false,
                Filetype: '',
                IdPId: ''
            };
            this.gridOptions = this.ReportUtils.getDefaultGridOptions(this);
            this.rowCount = '';
            this.traceProgress.start();
            this.SettingsService.getSettings().then((response) => {
                const appSettings = response.data;
                this.state.showReport = true;
                this.state.DateFormats = {
                    DateTimeFormat: appSettings.DateTimeFormat,
                    DateFormat: appSettings.DateFormat,
                    TimeFormat: appSettings.TimeFormat
                };
                this.state.expiryLimit = appSettings.TestSuiteExpiryWarningDayLimit;
            });
            this.UserDetailsApi.get().then((response) => {
                this.state.userDetails = response.data; // setup our user details
                this.getTestSuiteExpiryReport();
                this.state.selectedExpiryType = {
                    Id: 0,
                    Name: 'All Expiry Types'
                };
                this.traceProgress.complete();
            }, () => {
                this.traceProgress.complete();
                this.toastr.error('Please make sure that you are logged in to OTS UTP!');
                this.window.location.href =
                    this.browser.baseHref() + 'account/login';
                return;
            });
            this.ReportServiceApi.getReportByName('TestSuiteExpiryReport').then((response) => {
                if (Object.keys(response.data).length > 0) {
                    this.testSuiteExpiryReport = response.data;
                }
                else {
                    this.toastr.warning('Report descriptions not found');
                }
            });
        };
        this.browser = $browser;
        this.window = $window;
        this.location = $location;
        this.toastr = toastr;
        this.moment = moment;
        this.ngProgressFactory = ngProgressFactory;
        this.SettingsService = SettingsService;
        this.UserDetailsApi = UserDetailsApi;
        this.ReportService = ReportUtilityServiceApi;
        this.ReportServiceApi = ReportServiceApi;
        this.ReportUtils = ReportUtils;
    }
}
angular.module('app').component('testSuiteExpiryReport', {
    templateUrl: 'Scripts/App/partials/Reports/test-suite-expiry-report.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: TestSuiteExpiryReportController
});
